import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../lib/api';
import type { CurrentUser } from '../types';

interface AuthState {
  user: CurrentUser | null;
  loading: boolean;
}

export function useAuth(): AuthState {
  const navigate = useNavigate();
  const [state, setState] = useState<AuthState>({ user: null, loading: true });

  useEffect(() => {
    authApi
      .me()
      .then((user) => setState({ user, loading: false }))
      .catch(() => {
        navigate('/login', { replace: true });
      });
  }, [navigate]);

  return state;
}
